import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/login.jpg'


const _hoisted_1 = { class: "login full-height" }
const _hoisted_2 = { class: "roba-container flex flex-align-end" }
const _hoisted_3 = { class: "flex flex-grow-1 flex-align-center flex-justify-center" }
const _hoisted_4 = { class: "card flex" }
const _hoisted_5 = { class: "content white pa-4" }
const _hoisted_6 = { class: "bottom-links flex flex-justify-center gray3--text mb-2" }
const _hoisted_7 = {
  class: "mr-4",
  target: "_blank",
  href: "https://www.robametals.com/content/uploads/2021/03/General-purchasing-conditions-EN.pdf"
}
const _hoisted_8 = {
  class: "mr-4",
  target: "_blank",
  href: "https://www.robametals.com/content/uploads/2021/03/General-sales-conditions-EN.pdf"
}
const _hoisted_9 = {
  target: "_blank",
  href: "https://www.robametals.com/content/uploads/2021/03/Disclaimer-EN.pdf"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      class: "login__header",
      style: _normalizeStyle({ height: `${_ctx.headerHeight}px` })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: {name:"auth"}
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              class: "roba-logo",
              src: _imports_0
            }, null, -1)
          ]))]),
          _: 1
        })
      ])
    ], 4),
    _createElementVNode("div", {
      class: "roba-container flex flex-column",
      style: _normalizeStyle({height: `calc(100vh - ${_ctx.headerHeight}px)`})
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("img", { src: _imports_1 }, null, -1)),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.showSupportButton)
              ? (_openBlock(), _createBlock(_Transition, {
                  key: 0,
                  name: "fade"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      class: "text-button support-link",
                      to: {name: "login-support"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('COMMON.HELP')), 1),
                        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "icons8-help" }, null, -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("div", {
                  class: "login-route-content",
                  key: _ctx.$route.fullPath
                }, [
                  _createVNode(_component_router_view)
                ]))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('LOGIN.GENERAL_PURCHASING_CONDITIONS')), 1),
        _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('LOGIN.GENERAL_SALES_CONDITIONS')), 1),
        _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t('LOGIN.DISCLAIMER')), 1)
      ])
    ], 4)
  ]))
}